import { render, staticRenderFns } from "./ServicePredictDetails.vue?vue&type=template&id=7984d4b3&scoped=true&"
import script from "./ServicePredictDetails.vue?vue&type=script&lang=js&"
export * from "./ServicePredictDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServicePredictDetails.vue?vue&type=style&index=0&id=7984d4b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984d4b3",
  null
  
)

export default component.exports